// Конфигурация для отображения свойств
export const PROPERTY_CONFIG = {
    default: {
        color: 3,
        country: 0,
        netVolume: 5,
        region: 2,
        sugarType: 4,
        productType: 1,
    },
    list: {
        color: 3,
        country: 0,
        grapeContent: 6,
        manufacturer: 7,
        ageExtract: 8,
        netVolume: 5,
        region: 1,
        productType: 2,
        styleWine: 9,
        sugarType: 4,
        barrell: 10,
        agingCategory: 11,
    },
};

// маппинг кодов свойств для фильтров
export const FILTER_CODES = {
    color: 'color',
    country: 'country',
    grapeContent: 'grape',
    manufacturer: 'manufacturer',
    netVolume: 'volume',
    region: 'region',
    sugarType: 'sugar_type',
    productType: 'product_type',
    barrell: 'barrell',
    agingCategory: 'konyak_class',
} as const;
